/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for UserCOC.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SD_COC_APPLICATION_FORM = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `USERCOC/FETCH_SD_COC_APPLICATION_FORM`
);

const FETCH_SD_EXTERNALUSER_COC_STATUS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `USERCOC/FETCH_SD_EXTERNALUSER_COC_STATUS`
);

const DELETE_APPLICATION_FORM_BY_APPLICATION_FORM_ID = ReduxUtils.generateActionTypes(
  'ua-library',
  `USERCOC/DELETE_APPLICATION_FORM_BY_APPLICATION_FORM_ID`,
  'DELETE'
);

export {
  FETCH_SD_COC_APPLICATION_FORM,
  FETCH_SD_EXTERNALUSER_COC_STATUS,
  DELETE_APPLICATION_FORM_BY_APPLICATION_FORM_ID,
};
